import React from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { useAppContext } from 'providers/AppProvider';
import { TooltipComponent } from 'echarts/components';
import { GaugeChart } from 'echarts/charts';
echarts.use([TooltipComponent, GaugeChart]);

interface ScoredVsNonScoredChartProps {
  percentage: number;
}

const getDefaultOptions = (
  getThemeColor: (name: string) => string,
  percentage: number
) => ({
  tooltip: {
    show: false
  },
  legend: { show: false },
  series: [
    {
      type: 'gauge',
      center: ['50%', '50%'],
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 100,
      splitNumber: 12,
      itemStyle: {
        color: getThemeColor('primary')
      },
      progress: {
        show: true,
        roundCap: true,
        width: 10,
        itemStyle: {
          shadowBlur: 0,
          shadowColor: '#0000'
        }
      },
      pointer: {
        show: false
      },
      axisLine: {
        roundCap: true,
        lineStyle: {
          width: 10,
          color: [[1, getThemeColor('primary-bg-subtle')]]
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      title: {
        show: true,
        offsetCenter: [0, '100%'], // Mueve el título hacia arriba
        fontSize: 10, // Ajusta el tamaño de la fuente del título
        color: getThemeColor('light-text-emphasis')
      },
      detail: {
        show: true,
        valueAnimation: true,
        fontSize: 13,
        offsetCenter: [1, '60%'],
        color: getThemeColor('light-text-emphasis'),
        formatter: '{value}%'
      },
      data: [
        {
          value: percentage.toFixed(2),
          name: 'Scored calls'
        }
      ]
    }
  ]
});

const ScoredVsNonScoredChart: React.FC<ScoredVsNonScoredChartProps> = ({
  percentage
}) => {
  const { getThemeColor } = useAppContext();

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getDefaultOptions(getThemeColor, percentage)}
      style={{ height: '85px', width: '95px' }}
    />
  );
};

export default ScoredVsNonScoredChart;
